import * as http from '../utils/request'
import {
  getLoginData
} from "@/utils/auth";

export function setConfig(params = {}, urlParams = {}) {
  let userInfo = getLoginData();
  let tenantId = userInfo.tenant_id;
  let thingsId = urlParams.thingsId

  return http.postJSON(`/v1/things/tenants/${tenantId}/things/${thingsId}/messages?async=false&save_log=false&timeout=30000`, params, false)

  // return http.putJSON("/v1/devices/"+devId+"/commands/set_config?devtype="+devtype+"&cmdtype=confirmed",config,false)
}

export function report(params = {}, urlParams = {}) {
  // let params={"M_R2":1,"M_PTcellov":1,"M_PTcellvu":1,"M_PTcellvd":1,"M_PTtvo":1,"M_PTtvu":1,"M_PTtempco":1,"M_PTtempcu":1,"M_PTtempdo":1,"M_PTtempdu":1,"M_PTtempeo":1,"M_PTtempeu":1,"M_PTtempmo":1,"M_PTsocu":1,"M_PTcurco":1,"M_PTcurdo":1,"M_PTtempbo":1,"M_PTresu":1};

  let userInfo = getLoginData();
  let tenantId = userInfo.tenant_id;
  let thingsId = urlParams.thingsId

  return http.postJSON(`/v1/things/tenants/${tenantId}/things/${thingsId}/messages?async=false&save_log=false&timeout=30000`, params, false)

  // return http.putJSON("/v1/devices/"+devId+"/commands/M_report?devtype="+devtype+"&cmdtype=confirmed",params,false)
}

export function pReport(params = {}, urlParams = {}) {
  let userInfo = getLoginData();
  let tenantId = userInfo.tenant_id;
  let thingsId = urlParams.thingsId

  return http.postJSON(`/v1/things/tenants/${tenantId}/things/${thingsId}/messages?async=false&save_log=false&timeout=30000`, params, false)

  // let params={"P_no":P_no,"PX_R2":1,"PX_PTcellov":1,"PX_PTcellvu":1,"PX_PTcellvd":1,"PX_PTtvo":1,"PX_PTtvu":1,"PX_PTtempco":1,"PX_PTtempcu":1,"PX_PTtempdo":1,"PX_PTtempdu":1,"PX_PTtempeo":1,"PX_PTtempeu":1,"PX_PTtempmo":1,"PX_PTsocu":1,"PX_PTcurch":1,"PX_PTcurdh":1};
  // return http.putJSON("/v1/devices/"+devId+"/commands/P_report?devtype="+devtype+"&cmdtype=confirmed",params,false)
}

export function reset(params = {}, urlParams = {}) {

  let userInfo = getLoginData();
  let tenantId = userInfo.tenant_id;
  let thingsId = urlParams.thingsId

  return http.postJSON(`/v1/things/tenants/${tenantId}/things/${thingsId}/messages?async=false&save_log=false&timeout=30000`, params, false)


  // let params={};
  // return http.putJSON("/v1/devices/"+devId+"/commands/M_reset?devtype="+devtype+"&cmdtype=confirmed",params,false)
}


export function upgrade(deviceId, params={}) {
  let userInfo = getLoginData();
  let tenantId = userInfo.tenant_id;

  return http.postJSON(`/v1/things/tenants/${tenantId}/things/${deviceId}/messages?async=false&save_log=false&timeout=30000`, params,false)
}

export function packageInfo(params) {
  let userInfo = getLoginData();
  let tenantId = userInfo.tenant_id;
  
  return http.get(`/v1/out-filemanager/tenants/${tenantId}/package/lastPackage`,params);
}

// export function setConfig(devId,config={}) {
//   return http.putJSON("/v1/devices/"+devId+"/commands/set_config?devtype=HE_BAT&cmdtype=confirmed",config,false)
// }

export function getConfig(devId,devtype) {
  return http.get2("/v1/devices/"+devId,{"devtype":devtype})
}

export function  getLastData(devId) {

  return http.postJSON("/v1/devices/batch/lastdata?devtype=HE_BAT",[{"devid":devId,"devtype":'HE_BAT'}])
}

//
// https://www.zlgcloud.com/api-explorer#/%E8%AE%BE%E5%A4%87%E6%95%B0%E6%8D%AE/batchLastData
